import React, { useState } from "react";
import { MainHeading, Section, Container } from "../../components";
import { LoginForm } from ".";
import useHostNameStore from "../../stores/useHostNameStore";

const LoginPage: React.FC = () => {
	const [_, setIsLoading] = useState(false);
	const { setHostName } = useHostNameStore();

	const fullHostName = window.location.hostname.toUpperCase();
	const hostName = fullHostName.split(".");

	const handleFormSubmit = (email: string) => {
		setHostName(hostName[0]);
		setIsLoading(true);
	};
	const additionalSectionClasses = "mb-12 text-center mt-20 text-4xl";

	return (
		<Container size="sm" containerClasses="container mx-auto px-4">
			<Section additionalClasses="text-center font-omnes-medium font-normal">
				<MainHeading
					text="Log In"
					additionalClasses={additionalSectionClasses}
				/>
				<LoginForm onSubmit={handleFormSubmit} />
			</Section>
		</Container>
	);
};

export default LoginPage;
